<script lang="ts">
import BaseCard from '@/components/cards/new/BaseCard.vue'
import { defineComponent } from 'vue'

/**
 * BenefitCard
 */
export default defineComponent({
  components: {
    BaseCard,
  },
})
</script>

<template>
  <BaseCard>
    <div class="card-media">
      <slot name="media">
        <div class="h-40 w-full bg-slate-100"></div>
      </slot>
    </div>

    <div class="flex-1">
      <slot></slot>
    </div>

    <slot name="actions"></slot>
  </BaseCard>
</template>

<style lang="scss" scoped>
@tailwind components;

@layer components {
  .card-media {
    @apply -mx-5 -mt-5;
  }
  .basecard .basecard :deep(.card-media) {
    @apply -mx-4 -mt-4;
  }
}
</style>
